import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Grid,
  Alert,
  CircularProgress,
} from '@mui/material';
import { CreateInvoiceData } from '@/models/invoice';
import './SmartInvoiceDetails.css';

export interface SmartInvoiceDetailsProps {
  formData: CreateInvoiceData;
  onFieldChange: (field: string, value: any) => void;
  errors: Record<string, string>;
  disabled?: boolean;
  loading?: boolean;
}

const SmartInvoiceDetails: React.FC<SmartInvoiceDetailsProps> = ({
  formData,
  onFieldChange,
  errors,
  disabled = false,
  loading = false
}) => {
  return (
    <Box className="smart-invoice-details">
      {/* Header */}
      <Box className="sid-form-header">
        <Typography variant="h6" className="sid-form-title">
          Invoice Details
        </Typography>
      </Box>

      {/* Content - Always in Edit Mode */}
      <Box className="sid-form-content">
        {loading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 180, width: '100%' }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box className="sid-edit-mode">
            <Grid container spacing={2} className="sid-field-row">
            <Grid item xs={12} sm={6}>
              <TextField
                label="Invoice Number *"
                value={formData.invoice_number || ''}
                onChange={(e) => onFieldChange('invoice_number', e.target.value)}
                error={!!errors.invoice_number}
                helperText={errors.invoice_number}
                disabled={disabled}
                fullWidth
                size="small"
                placeholder="e.g., INV/24-25/001"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Invoice Date *"
                type="date"
                value={formData.invoice_date || ''}
                onChange={(e) => onFieldChange('invoice_date', e.target.value)}
                error={!!errors.invoice_date}
                helperText={errors.invoice_date}
                disabled={disabled}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Order Date *"
                type="date"
                value={formData.order_date || ''}
                onChange={(e) => onFieldChange('order_date', e.target.value)}
                error={!!errors.order_date}
                helperText={errors.order_date}
                disabled={disabled}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Transport"
                value={formData.transport || ''}
                onChange={(e) => onFieldChange('transport', e.target.value)}
                error={!!errors.transport}
                helperText={errors.transport}
                disabled={disabled}
                fullWidth
                size="small"
                placeholder="Enter transporter name"
              />
            </Grid>
          </Grid>
        </Box>
        )}
      </Box>
    </Box>
  );
};

export default SmartInvoiceDetails; 